<template>
  <div class="popup">
    <div class="popup_content fbl_cal"  :style="{width : onlinestate=='pc' ?'25rem':'20rem'}">
        <div style="display: flex;">
            <div class="jjrg_text" style="font-size: 18px;font-weight: 600;margin-top: 0.5rem;color: #09666e;;">{{htmlFlag == 2 ? $lang.jjrg : $lang.zqrg }}</div>
            <div style="margin-left:auto;cursor: pointer;" @click="popClose()">
              <svg t="1702432017007" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4232" width="19" height="19"><path d="M548.992 503.744L885.44 167.328a31.968 31.968 0 1 0-45.248-45.248L503.744 458.496 167.328 122.08a31.968 31.968 0 1 0-45.248 45.248l336.416 336.416L122.08 840.16a31.968 31.968 0 1 0 45.248 45.248l336.416-336.416L840.16 885.44a31.968 31.968 0 1 0 45.248-45.248L548.992 503.744z" p-id="4233" fill="#707070"></path></svg>
            </div>
            <!-- <div style="margin-left:auto;font-size: 1.5rem;position: relative;top: -1rem;cursor: pointer;" @click="popClose()">×</div> -->
        </div>
        <div style="width: 100%;text-align: center;">
            <img class="logo_img" :src="logoimg" alt="" style="margin: 1rem 0;">
        </div>
        <div>
            <a-input :placeholder="$lang.zqzh" :class="{'border_red': obj.flag1}"  @input="obj.flag1=false" class="jjfw_inp" v-model="account" style="margin-top: 1rem;">
              <template #prefix>
                <svg t="1702435058896" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8197" width="19" height="19"><path d="M512 563.2c-155.136 0-281.6-126.464-281.6-281.6S356.864 0 512 0s281.6 126.464 281.6 281.6-126.464 281.6-281.6 281.6z m0-512c-126.976 0-230.4 103.424-230.4 230.4s103.424 230.4 230.4 230.4 230.4-103.424 230.4-230.4-103.424-230.4-230.4-230.4zM512 1024H102.4c-14.336 0-25.6-11.264-25.6-25.6 0-183.296 59.904-277.504 110.592-324.608C244.224 621.056 302.08 614.912 304.64 614.4c13.824-1.536 26.624 8.704 28.16 23.04 1.536 13.824-8.704 26.624-22.528 28.16-7.68 1.024-172.032 24.064-181.76 307.2H512c14.336 0 25.6 11.264 25.6 25.6s-11.264 25.6-25.6 25.6z" fill="#2c2c2c" p-id="8198"></path><path d="M927.232 1024h-409.6c-14.336 0-25.6-11.264-25.6-25.6s11.264-25.6 25.6-25.6H901.12c-9.728-286.208-179.712-307.2-181.248-307.2-13.824-1.536-24.064-13.824-23.04-28.16s13.824-24.064 28.16-23.04c2.56 0 60.416 6.656 117.248 59.392 50.688 46.592 110.592 140.8 110.592 324.608 0 14.336-11.776 25.6-25.6 25.6z" fill="#2c2c2c" p-id="8199"></path></svg>
                <!-- <img src="../../../image/zh.png"> -->
              </template>
            </a-input>
            <div class="phone_num_class">
              <a-input  :placeholder="$lang.yhdh" :class="{'border_red': obj.flag2}"  @input="obj.flag2=false" class="jjfw_inp " v-model="phone_number" style="margin-top: 1rem;">
                <template #prefix>
                  <svg t="1702435419418" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16920" width="19" height="19"><path d="M736 0H288a128 128 0 0 0-128 128v768a128 128 0 0 0 128 128h448a128 128 0 0 0 128-128V128a128 128 0 0 0-128-128z m64 896a64 64 0 0 1-64 64H288a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64h448a64 64 0 0 1 64 64z" p-id="16921" fill="#2c2c2c"></path><path d="M512 848m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" p-id="16922" fill="#2c2c2c"></path></svg>
                  <!-- <div>1231</div> -->
                  <a-select v-model="qh"  class="qhXz" style="width: 4.5rem" >
                    <a-select-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value">
                      <span style="font-size:16px;">+{{ item.value }}</span>
                    </a-select-option>
                  </a-select>
                  <!-- <img src="../../../image/sj.png" > -->
                </template>
              </a-input>
            </div>
            <!-- <el-select v-model="form.qh" class="qhXz" >
									<el-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value">
										<span style="font-size:.65rem;float: left">{{ item.label }}</span>
										<span style="font-size:.65rem;float: right;">+{{ item.value }}</span>
									</el-option>
								</el-select> -->
            <!-- <a-input  :placeholder="$lang.yhdh" :class="{'border_red': obj.flag2}"  @input="obj.flag2=false" class="jjfw_inp phone_num_class" v-model="phone_number" style="margin-top: 1rem;">
              <template #prefix>
                <svg t="1702435419418" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16920" width="19" height="19"><path d="M736 0H288a128 128 0 0 0-128 128v768a128 128 0 0 0 128 128h448a128 128 0 0 0 128-128V128a128 128 0 0 0-128-128z m64 896a64 64 0 0 1-64 64H288a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64h448a64 64 0 0 1 64 64z" p-id="16921" fill="#2c2c2c"></path><path d="M512 848m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" p-id="16922" fill="#2c2c2c"></path></svg>
              </template>
            </a-input> -->
            <div style="display: flex;align-items: center;margin-top: 1rem;">
                <a-input :placeholder="$lang.sbm" :class="{'border_red': obj.flag3}" @input="obj.flag3=false" class="jjfw_inp" v-model="fund_code">
                  <template #prefix>
                    <svg t="1702434548998" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5904" width="20" height="20"><path d="M170.8 305.4c15.8 0 28.7-11.7 28.7-26.2v-57.6c0-7 7.1-12.8 14.8-12.8H808c7.7 0 13.1 5.7 13.1 12.8v57.6c0 14.5 12.8 26.2 28.7 26.2 15.8 0 28.7-11.7 28.7-26.2v-57.6c0-0.5 0.4-0.9 0.4-1.4-0.8-35.3-32-63.8-70.8-63.8H214.2c-38.8 0-70.8 28.5-71.6 63.8 0 0.4-0.5 0.9-0.5 1.4v57.6c0 14.4 12.9 26.2 28.7 26.2zM878.8 803.2c0-0.5-0.4-1.3-0.4-1.8v-57.6c0-14.5-12.8-26.2-28.7-26.2-15.8 0-28.7 11.7-28.7 26.2v57.6c0 0.5 0.5 1.1 0.5 1.6s0.2 1.5 0.2 2c0 7-6 13.1-13.7 13.1H214.2c-7.7 0-13.9-6.1-13.9-13.1 0-0.5-0.5-1.3-0.5-1.8s-0.4-1.3-0.4-1.8v-57.6c0-14.5-12.8-26.2-28.7-26.2-15.8 0-28.7 11.7-28.7 26.2v57.6c0 0.5 0.5 1.1 0.5 1.6s0.2 1.5 0.2 2c0 35.9 32.2 65.5 71.5 65.5H808c39.3 0 71.2-29.6 71.2-65.5 0.1-0.5-0.4-1.2-0.4-1.8zM178.6 513.2c0 25.9 22.9 46.8 51.3 46.8 28.3 0 51.3-21 51.3-46.8 0-25.9-22.9-46.8-51.3-46.8-28.3 0-51.3 21-51.3 46.8M366 513.2c0 25.9 22.9 46.8 51.3 46.8 28.3 0 51.3-21 51.3-46.8 0-25.9-22.9-46.8-51.3-46.8s-51.3 21-51.3 46.8M553.4 513.2c0 25.9 23 46.8 51.3 46.8s51.3-21 51.3-46.8c0-25.9-22.9-46.8-51.3-46.8s-51.3 21-51.3 46.8M740.8 513.2c0 25.9 22.9 46.8 51.3 46.8 28.3 0 51.3-21 51.3-46.8 0-25.9-23-46.8-51.3-46.8-28.4 0-51.3 21-51.3 46.8" fill="#2c2c2c" p-id="5905"></path></svg>
                    <!-- <img src="../../../image/sbm.png"> -->
                  </template>
                </a-input>
                <div class="yzm_class" @click="generateVerificationCode()">{{verificationCode}}</div>
            </div>
        </div>
        <!-- @click="btnClick()" -->
        <div class="btn_class" @click="savaClick()">{{$lang.tj}}</div>
    </div>
    <a-modal
      id="hkidr_msg"
      v-model="okFlag"
      :width="onlinestate == 'pc' ? islang == 'eng' ? false ? '33%': '24%' : '550px'  : '80%'"
      on-ok="handleOk"
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{ top: onlinestate == 'pc' ? '34vh' : '30vh' }"
    >
      <div class="mark-file">
        <div
          style="
            width: 100%;
            font-size: 18px;
            text-align: center;
            color: #000;
            font-weight: 600;
          "
          class="my_fonts"
        >
          <div
            style="font-size: 21px; padding: 12px 0"
            :style="islang == 'eng' ? 'font-size: 19px' : '21px'"
          >
            {{ islang == "eng" ? "Reminder" : "提示" }}
          </div>
          <div
            style="width: 100%; height: 1px; background-color: #d8d8d8"
          ></div>
        </div>
      </div>
      <div solt="title" style="position: relative"></div>
      <div
        style="
          font-size: 19px;
          font-weight: 600;
          margin-top: 8px;
          color: #000;
          text-align: center;
        "
        class="fbody"
      >
        <div style="display:flex;justify-content: center;" :style="{alignItems:islang == 'eng'?'flex-start':'center'}" class="fonts look_l" v-if="codflagt">
          <img :src="require('@/image/home/dialog_success.png')" style="width:30px;flex-shrink: 0;margin-right: 0.5rem;" >
          <div style="text-align: left;">{{codeText}}</div>
        </div>
        <div style="display:flex;align-items: flex-start;justify-content: center;" class="fonts look_l" v-else>
          <img :src="require('@/image/home/dialog_warning.png')" style="width:30px;flex-shrink: 0;margin-right: 0.5rem;">
          <div style="text-align: left;">{{codeText}}</div>
        </div>
        <a-button
          style="
            border-color: #0097a9;
            background-color: #0097a9;
            color: #fff !important;
            width: 90px;
            height: 40px;
          "
          @click="dilogok"
          >{{ islang == "eng" ? "Confirm" : "確認" }}</a-button
        >
      </div>
    </a-modal>
    <a-modal
      id="hkidr_msg"
      v-model="okFlag1"
      :width="onlinestate == 'pc' ?  '550px'  : '80%'"
      on-ok="handleOk"
      @cancel="handleCancel1(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{ top: onlinestate == 'pc' ? '34vh' : '30vh' }"
    >
      <div class="mark-file">
        <div
          style="
            width: 100%;
            font-size: 18px;
            text-align: center;
            color: #000;
            font-weight: 600;
          "
          class="my_fonts"
        >
          <div
            style="font-size: 21px; padding: 12px 0"
            :style="islang == 'eng' ? 'font-size: 19px' : '21px'"
          >
            {{ islang == "eng" ? "Reminder" : "提示" }}
          </div>
          <div
            style="width: 100%; height: 1px; background-color: #d8d8d8"
          ></div>
        </div>
      </div>
      <div solt="title" style="position: relative"></div>
      <div
        style="
          font-size: 19px;
          font-weight: 600;
          margin-top: 8px;
          color: #000;
          text-align: center;
        "
        class="fbody"
      >
        <div style="display:flex;align-items: flex-start;justify-content: center;padding:25px;" class="fonts look_l" v-if="status == '已過期'">
          <!-- <img :src="require('@/image/home/dialog_warning.png')" style="width:30px;flex-shrink: 0;margin-right: 0.5rem;"> -->
          <div style="text-align: left;" v-if="islang == 'eng'">Your Investment Orientation Questionnaire has expired. Please complete the questionnaire again.</div>
          <div style="text-align: left;" v-else>您的投資取向問卷已過期，請重新填寫問卷</div>
        </div>
        <div style="display:flex;align-items: flex-start;justify-content: center;padding:25px;" class="fonts look_l" v-else>
          <!-- <img :src="require('@/image/home/dialog_warning.png')" style="width:30px;flex-shrink: 0;margin-right: 0.5rem;"> -->
          <div style="text-align: left;" v-if="islang == 'eng'">Prior to subscribe any Investment Product, you are required to complete the “Investment Orientation Questionnaire”.</div>
          <div style="text-align: left;" v-else>閣下認購投資產品，需填寫投資取向問卷。</div>
        </div>
        <a-button
          style="
            border-color: #0097a9;
            color: #0097a9 !important;
            width: 100px;
            height: 40px;
          "
          @click="weqtsClick(1)"
          >{{ islang == "eng" ? "Cancel" : "取消" }}
        </a-button>
        <a-button
          style="
            border-color: #0097a9;
            background-color: #0097a9;
            color: #fff !important;
            width: 100px;
            height: 40px;
            margin-left:1rem;
          "
          @click="weqtsClick(2)"
          >{{ islang == "eng" ? "Confirm" : "確認" }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import logoimg from '../../../image/home/qmislogohkidr.png'
export default {
  props:['htmlFlag','params'],
    components: {
        logoimg
    },
    data() {
      return {
        qhArr:[
          {id:'1',value: '86',label: this.$lang.zgdl }, 
          {id:'2',value: '852',label: this.$lang.zgxg}, 
          {id:'3',value: '853',label: this.$lang.zgam }, 
          {id:'4',value: '61',label: this.$lang.adly }, 
          {id:'5',value: '1',label: this.$lang.jnd },
          {id:'6',value: '60',label: this.$lang.mlxy },
          {id:'7',value: '1',label: this.$lang.mg },
          {id:'8',value: '65',label: this.$lang.xjp },
          {id:'9',value: '64',label: this.$lang.xxl }, 
          {id:'10',value: '44',label: this.$lang.yg }
        ],
        obj:{
          flag1:false,
          flag2:false,
          flag3:false,
        },
        codflagt:false,
        okFlag:false,
        okFlag1:false,
        qh:'852',
        codeText:'',
        logoimg:logoimg,
        account:'',
        phone_number:'',
        fund_code:'',
        verificationCode:'',
        onlinestate: sessionStorage["onlinestate"],
        islang: window.localStorage.guanwanglang,
        status:'',
      };
    },
    mounted() {
      if (this.islang == 'undefined') {
        this.islang = 'big5'
      }
      this.generateVerificationCode()
    },
    methods: {
        dilogok(){
            this.okFlag = false;
            // if (this.codflagt) {
            this.$emit('child',0)
            // }
        },
        generateVerificationCode() {
            const characters = '0123456789abcdefghijklmnopqrstuvwxyz';
            let code = '';
            for (let i = 0; i < 4; i++) {
                const index = Math.floor(Math.random() * characters.length);
                code += characters.charAt(index);
            }
            this.verificationCode = code;
        },
        btnClick(){
          console.log(this.params);
            document.body.style.overflow = 'auto';
            if (!this.account) {
              this.obj.flag1 = true
              return
            }
            if (!this.phone_number) {
              this.obj.flag2 = true
              return
            }
            if (this.verificationCode != this.fund_code) {
                this.obj.flag3 = true
                return
                // this.codflagt = true
                // this.codeText = '验证码正确'
                // this.okFlag = true;
            }
            let url = ''
            let data = {}
            if (this.htmlFlag == 2) {

              // this.$router.push('/fund_questionnaire')
              url = this.$api.submitCustomerFundInfo
              data={
                account:this.account,
                phone_number:'+'+this.qh+this.phone_number,
                fund_name:this.params.fund_name,
                fund_code:this.params.fund_code,
                lan:this.islang
              }
            }else{
              // this.$router.push('/fund_questionnaire')
              url = this.$api.submitCustomerBondInfo
              data={
                account:this.account,
                phone_number:'+'+this.qh+this.phone_number,
                bond_name:this.params.bond_name,
                bond_code:this.params.bond_code,
                lan:this.islang
              }
            }
            console.log(this.htmlFlag);
            // return
            this.$ajax({
              method: 'post',
              url: url,
              data:data
            }).then(res => {
              if (res.data.qmiscode == 1000) {
                // htmlFlag  2是基金 1是债券  等于2的话走问卷逻辑
                if (this.htmlFlag == 2) {
                  if (res.data.questionnaire == '1') {
                    // this.$router.push({ path: '/fund_questionnaire', query: { id: this.params.fund_code,account: this.account }})
                    this.$router.push({ path: '/fund_questionnaire', query: {  }})
                    let infoList = {
                      account:this.account,
                      phone_number:this.phone_number,
                      name:this.params.fund_name,
                      id:this.params.fund_code,
                    }
                    window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
                    // this.$router.push({ 
                    //   name: 'fund_questionnaire', 
                    //   params: { 
                    //     id: this.params.fund_code,
                    //     account: this.account 
                    //   }
                    // })
                  }else{
                    if (res.data.questionnaire == '2') {
                      this.okFlag1 = true;
                    }else{
                      this.codflagt = true
                      this.codeText = res.data.qmismsg
                      this.okFlag = true;
                    }
                  }
                }else{
                  if (res.data.questionnaire == '1') {
                    // this.$router.push({ path: '/bonds_questionnaire', query: { id: this.params.bond_code,account: this.account }})
                    this.$router.push({ path: '/bonds_questionnaire', query: {  }})
                    let infoList = {
                      account:this.account,
                      phone_number:this.phone_number,
                      name:this.params.bond_name,
                      id:this.params.bond_code,
                    }
                    window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
                  }else{
                    if (res.data.questionnaire == '2') {
                      this.okFlag1 = true;
                    }else{
                      this.codflagt = true
                      this.codeText = res.data.qmismsg
                      this.okFlag = true;
                    }
                  }
                }
              }else{
                this.codflagt = false
                this.codeText = res.data.qmismsg
                this.okFlag = true;

              }
            })
         
        },
        savaClick(){
          document.body.style.overflow = 'auto';
            if (!this.account) {
              this.obj.flag1 = true
              return
            }
            if (!this.phone_number) {
              this.obj.flag2 = true
              return
            }
            if (this.verificationCode != this.fund_code) {
                this.obj.flag3 = true
                return
                // this.codflagt = true
                // this.codeText = '验证码正确'
                // this.okFlag = true;
            }
            this.$ajax({
              method: 'post',
              url: this.$api.checkIOQSignStatus,
              data:{
                account:this.account,
                phone_number:'+'+this.qh+this.phone_number,
                lan:this.islang=='undefined' ? 'big5' : this.islang
              }
            }).then(res => {
              if (res.data.qmiscode == 1000) {
                let statusFlag =  res.data.status
                this.status = res.data.status
                // htmlFlag  2是基金 1是债券  等于2的话走问卷逻辑
                if (this.htmlFlag == 1) {
                  // 债券111111111111
                  if (statusFlag == '未簽署' || statusFlag == '已過期') {

                    this.okFlag1 = true
                    
                    // 跳填写问卷页面
                    // this.$router.push({ path: '/bonds_questionnaire', query: {  }})
                    // let infoList = {
                    //   account:this.account,
                    //   phone_number:this.phone_number,
                    //   name:this.params.bond_name,
                    //   id:this.params.bond_code,
                    // }
                    // window.sessionStorage.setItem('infoList',JSON.stringify(infoList))

                  }
                  if (statusFlag == '已提交') {
                    // 提示已提交弹窗
                    this.codflagt = false
                    this.codeText = res.data.show_info
                    this.okFlag = true;

                  }
                  if (statusFlag == '簽署成功') {
                    // 跳新页面
                    this.$router.push({ path: '/bonds_subscription', query: {  }})
                    let infoList = {
                      account:this.account,
                      phone_number:this.phone_number,
                      name:this.params.bond_name,
                      id:this.params.bond_code,
                    }
                    window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
                    
                  }

                    // this.$router.push({ path: '/fund_questionnaire', query: {  }})
                    // let infoList = {
                    //   account:this.account,
                    //   phone_number:this.phone_number,
                    //   name:this.params.fund_name,
                    //   id:this.params.fund_code,
                    // }
                    // window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
                    
                  }else{
                    // 1111111111基金
                    if (statusFlag == '未簽署' || statusFlag == '已過期') {

                      this.okFlag1 = true
                   

                    }
                    if (statusFlag == '已提交') {
                      // 提示已提交弹窗
                      this.codflagt = false
                      this.codeText = res.data.show_info
                      this.okFlag = true;

                    }
                    if (statusFlag == '簽署成功') {
                      // 跳新页面
                      this.$router.push({ path: '/fund_subscription', query: {  }})
                      let infoList = {
                        account:this.account,
                        phone_number:this.phone_number,
                        name:this.params.fund_name,
                        id:this.params.fund_code,
                      }
                      window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
                      
                    }
                    
                  }
               
              }else{
                this.codflagt = false
                this.codeText = res.data.qmismsg
                this.okFlag = true;

              }
            })

        },
        weqtsClick(val){
          if (val == 1) {
            this.okFlag1 = false;
            this.$emit('child',0)
          }else{
            if (this.htmlFlag == 1) {
              this.$router.push({ path: '/bonds_questionnaire', query: {  }})
              let infoList = {
                account:this.account,
                phone_number:this.phone_number,
                name:this.params.bond_name,
                id:this.params.bond_code,
              }
              window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
            }else{
              // 跳填写问卷页面
              this.$router.push({ path: '/fund_questionnaire', query: {  }})
              let infoList = {
                account:this.account,
                phone_number:this.phone_number,
                name:this.params.fund_name,
                id:this.params.fund_code,
              }
              window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
            }
           
          }
          // if (val == 1) {
          //   this.okFlag1 = false;
          //   this.$emit('child',0)
          // }else{
          //   if (this.htmlFlag == 2) {
          //     this.$router.push({ path: '/fund_questionnaire', query: {  }})
          //     let infoList = {
          //       account:this.account,
          //       phone_number:this.phone_number,
          //       name:this.params.fund_name,
          //       id:this.params.fund_code,
          //     }
          //     window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
          //   }else{
          //     this.$router.push({ path: '/bonds_questionnaire', query: {  }})
          //     let infoList = {
          //       account:this.account,
          //       phone_number:this.phone_number,
          //       name:this.params.bond_name,
          //       id:this.params.bond_code,
          //     }
          //     window.sessionStorage.setItem('infoList',JSON.stringify(infoList))
          //   }
          // }
        },
        popClose(){
            this.$emit('child',0)
        }

    },
}
</script>
<style>
  .ant-input:focus {
    box-shadow: none !important;
  }
  .ant-select-selection:focus{
    box-shadow: none !important;
  }
  .ant-select-open .ant-select-selection{
    box-shadow: none !important;
  }
  .ant-select-focused .ant-select-selection, .ant-select-selection:active, .ant-select-selection:focus{
    box-shadow: none !important;
  }
.qhXz .ant-select-selection__rendered {
   display: flex;
   align-items: center;

}
.qhXz .ant-select-selection {
    border: none !important;
    height: 100% !important;
    background: transparent;

}
 .border_red .ant-input{
    border-color: red !important;
  }
@media screen and (min-width:2200px){
  
  .fbl_cal{
    width: 22rem !important;
  }
  .fbl_cal .jjrg_text{
    font-size: 19px !important;
  }
  .fbl_cal .logo_img{
    width: 15rem !important;
  }
}
.jjfw_inp .ant-input{
    height: 2.3rem !important;
}
.ant-input-affix-wrapper .ant-input:not(:first-child){
    padding-left: 40px !important;
}
.phone_num_class .ant-input-affix-wrapper .ant-input:not(:first-child){
    padding-left:6.2rem !important;
}
.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled), .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
    background-color:#c1d6d4 !important;
  }
</style>

<style lang="sss" scoped>
  #hkidr_msg * {
    font-family: "Roboto", "Microsoft JhengHei", "sans-serif" !important;
  }
  #hkidr_msg .ant-modal-body {
  padding: 28px 0;
  padding-top: 0;
}
#hkidr_msg .ant-modal-close-x {
  font-size: 18px;
  top: 5px;
  position: relative;
}

#hkidr_msg .ant-modal-content {
  border-radius: 8px !important;
}

#hkidr_msg .ant-modal-content svg:hover {
  color: #09666e !important;
}
#hkidr_msg .ant-modal-close-x {
  display: none;
}
#hkidr_msg .myleft {
  text-align: right;
  padding-right: 4.7rem;
}
#hkidr_msg .myleft_en {
  text-align: right;
}
#hkidr_msg .look_l {
  font-size: 16px;
  padding: 25px 10px;
}
.btn_class{
    background: #0097a9;
    color: #fff;
    height: 2.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2.5rem 0 2rem;
    border-radius: 4px;
    cursor: pointer;
}
.yzm_class{
    width: 30%;
    height: 2.5rem;
    background: #fad3dc;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-left: 1rem;
    letter-spacing: 5px; /* 增加字符间距 */
    cursor: pointer;
    flex-shrink: 0;
    font-size: 0.8rem;

}
.popup{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}
.popup_content {
    background: #fff;
    padding: 20px;
    border-radius:4px;
}

</style>


// WEBPACK FOOTER //
// src/pages/bondfund/compoents/subscriptionBox.vue